class BlogPostsBanner {
  constructor({el, data, id}) {
    if (!el) return;
    this.section = el;
    this.id = id || null;
    this.data = data || null;
    this.grid    = el.querySelector('[data-bpb-grid]');
    this.flkty   = null;
    this.mql     = window.matchMedia('(max-width: 1120px)');

    this._onBreakpoint = this._onBreakpoint.bind(this);

    if (this.mql.addEventListener) {
      this.mql.addEventListener('change', this._onBreakpoint);
    } else {
      this.mql.addListener(this._onBreakpoint);
    }
    
    if (this.mql.matches) this._initFlickity();
  }

  _initFlickity() {
    if (!this.grid || this.flkty) return;

    this.flkty = this.setupFlickity({
          container: this.grid,
          cellSelector: '[data-bpb-card]',
          freeScroll: true,
          buttons: false,
          draggable: '>1'
    });
  }

  setupFlickity({ container, cellSelector, arrowShape, buttons, freeScroll, ...settings }) {
    if (!container) return null;
    return new (window.js_default())(container, {
      accessibility: false,
      adaptiveHeight: false,
      cellSelector: cellSelector ?? null,
      contain: true,
      margin: 20,
      cellAlign: 'center',
      friction: 0.5,
      freeScroll: !!freeScroll,
      initialIndex: 0,
      lazyLoad: false,
      percentPosition: false,
      prevNextButtons: !!buttons,
      arrowShape: arrowShape || null,
      pageDots: true,
      autoPlay: true,
      ...settings
    });
  }

  _destroyFlickity() {
    if (!this.flkty) return;
    this.flkty.destroy();
    this.flkty = null;
  }

  _onBreakpoint(e) {
    if (e.matches) {
      this._initFlickity();
    } else {
      this._destroyFlickity();
    }
  }

  destroy() {
    if (this.mql.removeEventListener) {
      this.mql.removeEventListener('change', this._onBreakpoint);
    } else {
      this.mql.removeListener(this._onBreakpoint);
    }
    this._destroyFlickity();
  }
}


document.addEventListener('DOMContentLoaded', () => {
  const section = new window.Sections()

  section.register('static-blog-new_layout', section => new BlogPostsBanner(section));
});

